// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"49d272c7","268":"55eb7d42"}[chunkId] + ".chunk.css";
};